var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-releases"},[_vm._l((_vm.releases),function(release){return _c('release',{key:release.id,attrs:{"data":release}})}),_vm._v(" "),(_vm.loading)?_c('VueLoadingIndicator',{staticClass:"overlay primary big"}):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b229453","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ModuleReleases.vue
// module id = 529
// module chunks = 0